export enum ListSortDirection {
  Ascending = 0,
  Descending = 1,
}
